<template>
  <div>
    <sweet-modal
      overlay-theme="dark"
      hide-close-button
      ref="modal"
      enable-mobile-fullscreen
      class="no-padding-content"
      @close="modalClosed"
      :width="modalWidth"
    >
      <div class="bg-modal-gradient flex justify-between items-center p-6">
        <div class="text-white text-3xl">
          <i class="fa fa-comment mr-4"></i> View discussion
        </div>
        <div>
          <button
            type="button"
            class="text-white text-2xl hover:text-grey"
            @click="$refs.modal.close()"
          >
            <i class="fa fa-times"></i>
          </button>
        </div>
      </div>

      <div class="flex flex-col md:flex-row">
        <div
          class="iframe-container flex-1 mr-2"
          v-if="
            selected_discussion.files != undefined &&
            selected_discussion.files.length > 0
          "
        >
          <div
            class="justify-center items-center h-screen flex flex-col"
            v-if="previewLoading"
          >
            <i class="fa fa-circle-notch fa-spin"></i>
            loading
          </div>
          <iframe
            :src="previewUrl"
            frameborder="0"
            style="overflow: hidden; height: 100%; width: 100%"
            height="100%"
            width="100%"
            class="iframe"
          ></iframe>
        </div>
        <div class="flex-1">
          <div class="px-6 pt-6">
            <p class="text-lg text-left border-b font-semibold mb-4">
              {{ selected_discussion.discussion.title }}
            </p>
            <div
              class="flex items-start mb-4 flex-col"
              v-if="
                selected_discussion.files &&
                selected_discussion.files.length > 0
              "
            >
              <p class="font-medium text-sm">Attached files</p>
              <div class="text-left text-sm flex flex-row flex-wrap">
                <div
                  v-for="file in selected_discussion.files"
                  :key="file.id"
                  class="my-1 mr-4 cursor-pointer"
                >
                  <i class="fa fa-file mr-1 text-brand"></i>
                  <a
                    @click.prevent="previewFile(file)"
                    class="text-black underline hover:text-brand"
                  >
                    {{ file.filename }}
                  </a>
                </div>
              </div>
            </div>
            <div
              class="flex items-start mb-4 flex-col"
              v-if="
                selected_discussion.discussion.users &&
                selected_discussion.discussion.users.length > 0
              "
            >
              <div class="flex justify-between w-full">
                <p class="font-medium text-sm">Participant</p>
                <button
                  type="button"
                  class="font-medium text-sm text-brand underline"
                  @click="showAllParticipant = !showAllParticipant"
                >
                  {{ showAllParticipant ? "Hide" : "Show all" }}
                </button>
              </div>
              <div class="text-left text-sm flex flex-row flex-wrap">
                <div
                  v-for="(user, index) in selected_discussion.discussion.users"
                  :key="user.id"
                >
                  <div
                    v-if="
                      showAllParticipant || (!showAllParticipant && index < 2)
                    "
                    class="my-1 mr-4"
                  >
                    <i class="fa fa-user mr-1 text-brand"></i>
                    <span>
                      {{ user.first_name ? user.first_name : "" }}
                    </span>
                    <span>
                      {{ user.last_name ? user.last_name : "" }}
                    </span>
                  </div>
                </div>

                <div
                  v-if="
                    !showAllParticipant &&
                    selected_discussion.discussion.users.length > 2
                  "
                  class="text-sm flex items-center"
                >
                  {{ selected_discussion.discussion.users.length - 2 }}
                  others...
                </div>
              </div>
            </div>
            <div
              class="
                border border-brand
                rounded-lg
                p-4
                overflow-y-scroll
                conversation
              "
              ref="messages"
            >
              <div
                v-if="
                  selected_discussion.messages_pagination != undefined &&
                  selected_discussion.messages_pagination.total > 0
                "
              >
                <div
                  v-for="(message, idx) in selected_discussion.raw_messages"
                  :key="idx"
                  class="rounded-lg text-grey-dark flex my-4"
                >
                  <div
                    v-if="message.user_id == user.id"
                    class="flex-1 flex text-right"
                  >
                    <div
                      class="flex-1 bg-grey-light rounded-lg p-2 mx-2 text-sm"
                    >
                      <p class="flex justify-between">
                        <span class="font-light text-xs">{{
                          formatDate(message.created_at)
                        }}</span>
                        <span class="font-semibold text-brand"
                          >{{ message.user.first_name }}
                          {{ message.user.last_name }}</span
                        >
                      </p>
                      <p>{{ message.content }}</p>
                    </div>
                    <div class="flex-none">
                      <i class="fa fa-user-circle text-brand fa-3x"></i>
                    </div>
                  </div>

                  <div v-else class="flex-1 flex text-left">
                    <div class="flex-none">
                      <i class="fa fa-user-circle text-grey fa-3x"></i>
                    </div>
                    <div
                      class="flex-1 bg-grey-lighter rounded-lg p-2 mx-2 text-sm"
                    >
                      <p class="flex justify-between">
                        <span class="font-medium"
                          >{{ message.user.first_name }}
                          {{ message.user.last_name }}</span
                        >
                        <span class="font-light text-xs">{{
                          formatDate(message.created_at)
                        }}</span>
                      </p>
                      <p>{{ message.content }}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="bg-grey-lighter text-center py-4 text-grey"
                v-observe-visibility="getNextMessages"
                v-if="add_msg_loader"
              >
                <i class="fa fa-spin fa-circle-notch"></i> loading messages...
              </div>
            </div>
          </div>
          <form
            class="bg-grey-lighter text-left mx-6 mt-4 mb-6 p-4 rounded"
            @submit.prevent="sendReply"
            data-vv-scope="reply-discussion"
          >
            <label class="font-medium"
              >Message <span class="text-red">*</span></label
            >
            <textarea
              type="text"
              class="w-full border rounded py-2 px-3 mt-1"
              v-model="reply_discussion.body"
              tabindex="1"
              v-validate="'required'"
              name="reply_body"
              :class="{
                'border-red': errors.has('reply-discussion.reply_body'),
              }"
            ></textarea>
            <div
              v-show="errors.has('reply-discussion.reply_body')"
              class="text-red text-sm mt-1"
            >
              Message is required
            </div>
            <div class="mt-6 flex justify-between items-center">
              <button
                class="bg-brand border border-brand text-white text-sm font-medium py-2 px-4 rounded hover:bg-brand-dark hover:border-brand-dark"
                type="submit"
              >
                <i class="fa fa-paper-plane mr-2"></i> Reply
              </button>
              <button
                v-is-authorized="{
                  roles: [role],
                  permissions: ['can_delete_discussions'],
                }"
                class="border border-red bg-white text-red text-sm font-medium py-2 px-4 rounded hover:bg-red hover:text-white"
                type="button"
                @click.prevent="$refs.delete_discussion.open()"
              >
                <i class="fa fa-trash"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
    </sweet-modal>

    <confirm-dialog
      ref="delete_discussion"
      title="Delete this discussion?"
      body="This cannot be undone."
      action-label="Delete"
      @confirm="deleteDiscussion"
    ></confirm-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ConfirmDialog from "../../../ConfirmDialog.vue";
import * as Sentry from "@sentry/vue";

export default {
  name: "ViewDiscussion",
  // fetchMessages comes from the Discussions panel; the modal sits in the
  // DashboardPanel slot, so $parent is the shell, not the panel.
  props: ["selected_discussion", "user", "fetchMessages"],
  data() {
    return {
      previewLoading: false,
      previewUrl: "",
      add_msg_loader: true,
      reply_discussion: {},
      showAllParticipant: false,
    };
  },
  methods: {
    deleteDiscussion() {
      axios
        .delete(
          `api/vaults/${this.$route.params.vault_id}/discussions/${this.selected_discussion.discussion.id}`
        )
        .then((response) => {
          if (response && response.data && response.data.success) {
            this.$emit("getDiscussions");
            this.$noty.success(response.data.message);
          }
        })
        .catch((e) => {
          Sentry.captureException(e);
          this.$noty.error(e.response.data.message);
        })
        .finally(() => {
          this.$refs.delete_discussion.close();
          this.$refs.modal.close();
        });
    },
    modalClosed() {
      this.previewUrl = "";
      this.showAllParticipant = false;
    },
    previewFile(file) {
      this.previewLoading = true;
      axios
        .get(`api/vaults/${file.vault_id}/files/${file.id}/download-path`, {
          params: {
            is_download: 0,
          },
        })
        .then(({ data }) => {
          this.previewLoading = false;
          if (/\.pdf$/i.test(file.filename)) {
            this.previewUrl =
              `/pdf_viewer_3/viewer.html?file=` + encodeURIComponent(data.url);
          } else {
            let office_file_exts = [
              "doc",
              "docx",
              "dotx",
              "odt",
              "ppt",
              "pptx",
              "odp",
              "xls",
              "xlsx",
              "ods",
            ];
            let file_ext_matches = file.filename.match(/[^.]+$/);
            if (file_ext_matches.length > 0) {
              let file_ext = file_ext_matches[0];
              if (office_file_exts.indexOf(file_ext) >= 0) {
                let baseURL = "https://docs.google.com/gview?url=";
                if(file_ext == "doc") {
                  baseURL = "https://view.officeapps.live.com/op/embed.aspx?src=";
                }
                // old URL: https://docs.google.com/viewer?url=
                this.previewUrl =
                  baseURL +
                  encodeURIComponent(data.url) +
                  "&embedded=true&headers=true";
              } else {
                this.previewUrl = data.url;
              }
            } else {
              this.previewUrl = data.url;
            }
          }
        });
    },
    sendReply() {
      this.$validator.validateAll("reply-discussion").then((result) => {
        if (result) {
          this.$emit("sending", true);
          axios
            .post(
              `api/vaults/${this.$route.params.vault_id}/discussions/${this.selected_discussion.discussion.id}/messages`,
              {
                message: this.reply_discussion.body,
              }
            )
            .then(({ data }) => {
              if (data.success) {
                this.add_msg_loader = true;
                this.selected_discussion.page = 1;
                this.$emit("sending", false);

                let container = this.$refs.messages;
                container.scrollTop = 0;

                this.reply_discussion.body = "";

                this.$noty.success("Message sent", {
                  killer: true,
                  timeout: 1500,
                });

                this.$ebus.$emit("update-discussion-count");

                this.$emit("getDiscussions");
                this.$emit(
                  "view-discussion",
                  this.selected_discussion.discussion
                );
              }
            });
        }
      });
    },
    getNextMessages() {
      if (!_.isEmpty(this.selected_discussion.discussion)) {
        this.selected_discussion.page++;
        this.fetchMessages(this.selected_discussion.discussion).then(
          ({ data }) => {
            if (_.isEmpty(data.data)) {
              this.add_msg_loader = false;
            }

            if (!_.isEmpty(this.selected_discussion.raw_messages)) {
              _.forEach(data.data, (datum) => {
                this.selected_discussion.raw_messages.push(datum);
              });
            } else {
              this.selected_discussion.raw_messages = data.data;
            }
          }
        );
      }
    },
    formatDate(date) {
      if (moment(date).isSame(moment(), "day")) {
        return moment(date).format("h:mm a");
      } else {
        return moment(date).format("MMM Do YYYY, h:mm a");
      }
    },
  },
  computed: {
    ...mapGetters({
      role: "getUserRole",
    }),

    modalWidth() {
      if (this.$mq == "mobile") {
        return "100%";
      } else {
        if (
          this.selected_discussion.files &&
          this.selected_discussion.files.length > 0
        ) {
          return "80%";
        }
      }
      return "50%";
    },
  },
  watch: {
    selected_discussion(value) {
      if (value.files && value.files.length > 0) {
        this.previewFile(value.files[0]);
      }
    },
  },
};
</script>

<style scoped>
button:focus {
  outline: none;
}

.no-padding-content .sweet-content .conversation {
  height: 400px;
}

.iframe-container {
  position: relative;
  padding-bottom: 56.25%; /* proportion value to aspect ratio 16:9 (9 / 16 = 0.5625 or 56.25%) */
  height: 0;
  overflow: hidden;
}

.iframe-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

@media (max-width: 768px) {
  .iframe-container {
    height: 75vh;
  }
}
</style>
